<template>
  <div class="c-nav-dropdown__links nav-with-icon">
    <sc-image v-if="fields && fields.icon" :media="fields.icon" class="c-nav-dropdown__icon" />
    <sc-text
      v-if="fields && fields.heading"
      :field="fields.heading"
      class="c-nav-dropdown__headline"
    />
    <div class="c-nav-dropdown__half">
      <div class="c-link-list">
        <sc-placeholder name="jss-bg-left" :rendering="rendering" />
      </div>
    </div>
    <div class="c-nav-dropdown__half">
      <div class="c-link-list">
        <sc-placeholder name="jss-bg-right" :rendering="rendering" />
      </div>
      <sc-link
        v-if="fields && fields.linkBg"
        :field="fields.linkBg"
        class="c-cta--tertiary"
        :class="fields.linkBg.value.class"
      />
    </div>
  </div>
</template>

<script>
import { Text, Image, Link, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-DropDown-LinkSectionWithBg',
  components: {
    ScText: Text,
    ScImage: Image,
    ScLink: Link,
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.nav-with-bg {
  .c-nav-dropdown__links {
    &.nav-with-icon {
      border: none;
      margin-left: 0;
      padding-left: 0;
      margin-bottom: 0;

      @include desktop-up {
        padding-left: 5rem;
        padding-right: 0;
      }

      .c-nav-dropdown__icon {
        left: 0;
      }
    }
  }

  .c-nav-dropdown__half {
    @include desktop-up {
      width: calc(50% - 1.5rem);
      padding-right: 1.5rem;
      display: inline-block;
      vertical-align: top;
    }

    &:last-child {
      @include desktop-up {
        padding-right: 0;
      }
    }
    .c-button__no-border {
      white-space: break-spaces;
    }
    .c-cta {
      &--tertiary {
        margin: 2rem auto auto;
        padding: 1.1rem 0rem 1.1rem 0;
        &:hover {
          &:after {
            left: 1rem;
          }
        }
      }
    }

    .c-link-list {
      @include desktop-up {
        width: 100%;
      }
    }
  }
}
</style>
